/* unplugin-vue-components disabled */import { render } from "./ChatListView.vue?vue&type=template&id=5e5a1ad0&scoped=true"
import script from "./ChatListView.vue?vue&type=script&lang=js"
export * from "./ChatListView.vue?vue&type=script&lang=js"

import "./ChatListView.vue?vue&type=style&index=0&id=5e5a1ad0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5a1ad0"]])

export default __exports__